/* eslint-disable no-console */
import axios from "axios"
import { AWS_BUCKET } from "const"
import {
    AwsGetObjectParams,
    AwsGetObjectResponse,
    AwsPutUrlParams,
    AwsPutUrlResponse,
    AwsDeleteObject,
    AwsDeleteParams,
    AwsDeleteResponse,
} from "server/routers/mtDriveCloudAws"
import { randomString, UploadCallback } from "client/utils"
import { POST } from "client/store/utils"
import { BalloonMessage } from "client/components"

export const AwsGetObject = (Key: string) => {
    const params: AwsGetObjectParams = {
        Bucket: AWS_BUCKET,
        Key,
    }

    return POST(
        "/aws/getObject",
        JSON.stringify(params),
    ).then((res: AwsGetObjectResponse) => {
        if (res.error) {
            BalloonMessage("Error file load. Check console")
            console.log(res.error)
            return null
        }
        return res.base64
    })
}

export const AwsUpload = (
    file: File,
    callback: UploadCallback,
) => {
    const id = new Date().getTime() + randomString(10)
    const params: AwsPutUrlParams = {
        Bucket: AWS_BUCKET,
        Key: id,
        ContentType: file.type,
    }

    POST(
        "/aws/generatePutUrl",
        JSON.stringify(params),
    ).then((res: AwsPutUrlResponse) => {
        if (res.error) {
            BalloonMessage("Error upload. Check console")
            console.log(res.error)
            callback(null, null)
        } else {
            axios.put(res.url, file, {
                headers: { "Content-Type": file.type },
            })
            .then(() => callback(id, null))
            .catch((err) => {
                BalloonMessage("Error upload. Check console")
                console.log(err)
                callback(null, null)
            })
        }
    })
}

export const AwsDelete = (versionIds: string[]) => {
    const Objects: AwsDeleteObject[] = []
    versionIds.forEach((id) => {
        Objects.push({ Key: id })
    })

    const params: AwsDeleteParams = {
        Bucket: AWS_BUCKET,
        Objects,
    }

    return POST(
        "/aws/deleteFromAWS",
        JSON.stringify(params),
    ).then((res: AwsDeleteResponse) => {
        if (res.error) {
            BalloonMessage("Error delete. Check console")
            console.log(res.error)
            return false
        }
        if (res.data && res.data.Errors && res.data.Errors.length) {
            BalloonMessage("Error delete. Check console")
            console.log(res.data.Errors)
            return false
        }
        return res
    })
}
